import React from 'react';
import '../Main.css';
import { images } from '../../../../constants';

const FeatureContent = ({ title, subtitle, description, image, contents }) => {
    return (
        <div className='feature-content-wrapper'>
            <div className='row feature-row'>
                <div className='col-12 col-lg-12 col-xl-6 feature-text-col'>
                    <div className='feature-text-content'>
                        <div className='feature-title'>
                            <div className='feature-label'>{title}</div>
                            <span className='feature-gradient'>{subtitle}</span> {description}
                        </div>
                        {contents && contents.map((content, index) => (
                            <div key={content.title || `content-${index}`} className='feature-list'>
                                {!!content.title && <h6 className='check-list-title'>{content.title}</h6>}
                                {content.checkList && content.checkList.map((item, itemIndex) => (
                                    <FeatureContentList key={`${content.title || index}-${itemIndex}`} content={item} />
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
                <div className='col-12 col-lg-12 col-xl-6 feature-image-col'>
                    <img src={image} alt='feature demo' className="img-fluid feature-image" />
                </div>
            </div>
        </div>
    )
}

const FeatureContentList = ({ content }) => (
    <div className='d-flex' style={{ gap: '12px' }}>
        <div className='d-flex align-items-center justify-content-center flex-shrink-1'>
            <img src={images.icon.circleCheckIcon} alt='tick' />
        </div>
        <div className='contentFeature flex-grow-1'>
            <p className='m-0'>{content}</p>
        </div>
    </div>
);
export default FeatureContent;